import React from "react";

const PeopleSearchEngine = ({ searchTerm, setSearchTerm }) => {
  return (
    <input
  type="text"
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  placeholder="Search by name, identity, or skills..."
  className="w-full sm:w-80 h-10 px-4 border border-gray-300 rounded-xl text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300"
/>

  );
};


export default PeopleSearchEngine;
